import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Problema from '../../../../assets/images/question.png';
import Foto1 from '../../../../assets/images/smarthome.jpeg';

import * as AiIcons from "react-icons/ai";
import * as BiIcons from "react-icons/bi";
import * as FcIcons from "react-icons/fc";
import * as MdIcons from "react-icons/md";

import IoT from './IoT/IoT';
import Conexoes from './Conexoes/Conexoes';
import Seguranca from './Seguranca/Seguranca';

import 'bootstrap/dist/css/bootstrap.min.css';


function Demanda() {
  const popover = (
    <Popover id="popover-basic">
      <Popover.Header as="h3">Popover Information</Popover.Header>
      <Popover.Body>
        Here is some <strong>interesting</strong> information about connected devices and their impact on Wi-Fi networks.
      </Popover.Body>
    </Popover>
  );

  const PopoverButton = () => (
    <OverlayTrigger trigger="click" placement="right" overlay={popover}>
      <Button variant="outline-primary" style={{ padding: '0 5px', margin: '0 5px', fontSize: 'inherit' }}>dispositivos conectados </Button>
    </OverlayTrigger>
  );

  const [activeTab, setActiveTab] = useState('/iot');

  const handleTabSelect = (selectedTab) => {
    setActiveTab(selectedTab);
  };

  return (
    <>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-sm-12 col-md-8'>
            <h1>Crescimento da demanda</h1>
            <img src={Problema} alt='problema' className='img-fluid mb-0' />

            <Tab.Container activeKey={activeTab} onSelect={handleTabSelect}>
              <Nav fill variant="tabs" defaultActiveKey="/iot">
                <Nav.Item>
                  <Nav.Link eventKey="/iot">
                    <div className='aba-menu'>
                      <h4><BiIcons.BiRss /></h4>
                      <h5>Dispositivos IoT</h5>
                    </div>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="/conexoes">
                    <div className='aba-menu'>
                      <h4><BiIcons.BiRss /></h4>
                      <h5>A confiabilidade das redes Wi-Fi</h5>
                    </div>
                  </Nav.Link>
                </Nav.Item>
                {/* <Nav.Item>
                  <Nav.Link eventKey="/seguranca">
                    <div className='aba-menu'>
                      <h4><BiIcons.BiRss />Conexões seguras</h4>
                      <h5></h5>
                    </div>
                  </Nav.Link>
                </Nav.Item> */}
              </Nav>
              <Tab.Content className='container'>
                    <Tab.Pane eventKey="/iot">
                        <IoT />
                    </Tab.Pane>                     
                    <Tab.Pane eventKey="/conexoes">
                        <Conexoes />
                    </Tab.Pane> 
                    {/* <Tab.Pane eventKey="/seguranca">
                        <Seguranca />
                    </Tab.Pane>                      */}
                </Tab.Content>
            </Tab.Container>
          </div>
          <div className='col-sm-12 col-md-4'>
            <div className='imagem'>
              <img className="d-block w-100" src={Foto1} alt="First slide" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Demanda;
